import React from 'react'
import AdminPage from 'pages/app/AdminPage'
import * as UI from 'ui'
import { Button, SubmitButton, ButtonTabs } from 'ui'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { Translation, Translator } from '@morningtrain/react-translations'
import {
  ForEachModel,
  ModelWithForm, SubmitFormOnPipe,
  ValueToCollection, WhenModel,
  WhenModelValue
} from '@morningtrain/react-resources'
import { RouteParameterFilter } from 'support/filters'
import CleaningCategorySectionTabs from 'pages/app/cleaning/partials/CleaningCategorySectionTabs'
import ConditionalStepCategorySection from 'pages/app/cleaning/partials/ConditionalStepCategorySection'
import { ResourceSelector } from 'support/fields'
import { Can } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'
import { Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import BackToOverview from 'widgets/navigation/BackToOverview'
import useDepartmentId from 'support/hooks/use-department-id'
import WhenCleaningCheckupIsCompleted from 'pages/app/cleaning/partials/WhenCleaningCheckupIsCompleted'
import PerformCheckupSteps from 'pages/app/cleaning/partials/PerformCheckupSteps'

export default function PerformCheckup () {
  const [departmentId] = useDepartmentId()

  return (
    <AdminPage withGlobalDepartmentFilter={false}>
      <Translator namespace='cleaning'>

        <ModelWithForm resourceName='cleaning.checkup' autoFetch={false} clean>
          <RouteParameterFilter name='cleaning_checkup' />

          <WhenModel>
            <UI.PageHeader title={(
              <TranslatedTitle name='titles.perform_checkup' />
            )}
            >
              <div className='flex space-x-2'>
                <BackToOverview route='app.cleaning.summary'>
                  <Translation name='actions.back_to_overview' />
                </BackToOverview>
                <WhenCleaningCheckupIsCompleted negate>
                  <ResourceSelector
                    className='flex-grow w-48 mr-4 -mt-6'
                    name='department_id'
                    optionsKey='name'
                    resourceName='departments'
                    defaultValue={departmentId}
                  />
                  <div className='flex justify-between items-center space-x-2'>
                    <Can permission={Permissions.CLEANING_CHECKUPS_MANAGE}>
                      <Pipeline>
                        <TriggerPipelineOnClick>
                          <Button type='button'>
                            <UI.WithIcon size={4} placement='right' icon={<UI.Icons.Checkmark />}>
                              <Translation name='actions.finish_checkup' />
                            </UI.WithIcon>
                          </Button>
                        </TriggerPipelineOnClick>
                        <SubmitFormOnPipe data={{ action: 'complete_checkup' }} />
                      </Pipeline>
                      <SubmitButton>
                        <Translation name='actions.save' />
                      </SubmitButton>
                    </Can>
                  </div>
                </WhenCleaningCheckupIsCompleted>
              </div>
            </UI.PageHeader>
            <PerformCheckupSteps />
          </WhenModel>

        </ModelWithForm>
      </Translator>
    </AdminPage>
  )
}
